import { CheckIcon, CopyIcon } from "@chakra-ui/icons";
import React from "react";

export function CopyToClipboard(props: { text: string; onCopied?: () => void }) {
  const [copied, setCopied] = React.useState(false);
  const timeoutRef = React.useRef<NodeJS.Timeout>();

  const handleCopyResult = () => {
    setCopied(true);
    navigator.clipboard.writeText(props.text);
    props.onCopied?.();
    if (timeoutRef.current !== undefined) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      setCopied(false);
      timeoutRef.current = undefined;
    }, 1200);
  };

  const Component = copied ? CheckIcon : CopyIcon;

  return <Component cursor="pointer" onClick={handleCopyResult} />;
}
